import {
    CreaJobOpeningInput,
    IJobOpeningModel,
    IJobOpeningRequest,
    IJobStatusInput,
    UpdateJobOpeningInput
} from './job-opening.types';

export class GetAllJobOpening {
    static readonly type = '[JobOpening] GET ALL JOBS';
}

export class AddJobOpening {
    static readonly type = '[JobOpening] Add JOB';
    constructor(public payload: CreaJobOpeningInput) {}
}

export class SelectJobOpening {
    static readonly type = '[JobOpening] Select Single JOB';
    constructor(public payload: IJobOpeningModel | null) {}
}

export class GetSingleJobOpening {
    static readonly type = '[JobOpening] Get one';
    constructor(public id: string) {}
}

export class GetJobOpeningBySlug {
    static readonly type = '[JobOpening] Get one slug';
    constructor(public slug: string) {}
}

export class GetJobOpening {
    static readonly type = '[JobOpening] Get job';
    constructor(public id: string) {}
}

export class UpdateJobOpening {
    static readonly type = '[JobOpening] Update JOB';
    constructor(public payload: UpdateJobOpeningInput) {}
}

export class UpdateJobOpeningStatus {
    static readonly type = '[JobOpening] Update JOB Status';
    constructor(public payload: IJobStatusInput) {}
}

export class DeleteJobOpening {
    static readonly type = '[JobOpening] Delete JOB';
    constructor(public id: string) {}
}

export class GetApplicationsByJob {
    static readonly type = '[JobOpening] get appls';
    constructor(public id: string) {}
}
